import React from "react";
import {connect} from "react-redux";
import BaseComponent from "../../base/BaseComponent";
import PageTemplate from "../newMediaMatrix/components/pageTemplate/PageTemplate";
import GradeTabs from "./components/GradeTabs";
import ScreenCard from "./components/screenCard/ScreenCard";
import SearchTemplate from "../newMediaMatrix/components/searchTemplate/SearchTemplate";
import {Button, Dropdown, Radio} from "antd";
import PositionCard from "./components/list/positionCard";
import PositionList from "./components/list/positionList";
import {Scrollbars} from "react-custom-scrollbars";
import ModeSelect from "./components/list/modeSelect/modeSelect";
import NoData from "./components/noData";
import {getActivityTypeData, getAllPositionTypeData} from "../newMediaMatrix/actions/actions";
import PositionAdd from "./components/info/PositionAdd";
import {uuid} from "../../utils";
import {message} from "../../utils/message";
import {setInfoToLocalStorage} from "../../actions";
import BtnGroup from "./components/BtnGroup";
import SortWay from "./components/list/sortWay/sortWay";
import ToDoGet from "./components/toDoGet";
import EntryList from "./components/entry/entryList";
import {CUSTOM_CONFIG} from "../../config/customConfig";

class PositionManage extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            params: {}, //列表查询条件
            typeData: [], //媒体类型全部数据
            mainUnitData: [], //主责单位数据
            divisionNameData: [
                {key: "线上平台", name: "线上平台"},
                {key: "线下平台", name: "线下平台"},
            ], //媒体划分数据
            listData: [],
            cardData: [],
            modeKey: "card",
            grade: "",
            showBatchAuditBtn: false,
            showBatchLingQuBtn: false,
            activityTypeData: [],
            isZombieCardData: false, //是否是僵尸媒体数据
            btnWidthList: [],
            mediaSort: [], //媒体排序，用户僵尸号排查后排序
            follow: false
        }

        this.screenCardRef = React.createRef();
    }

    componentDidMount() {
        this.getPositionMaintenanceData(() => {
            this.getListData(); //列表数据
        }); //平台维护全部数据
        this.getMainUnitData(); //主责单位数据
        this.getActivityType(); //流程类型数据
        this.getContainerWidth(); //获取容器宽度
        this.getMediaSort(); //媒体排序，用户僵尸号排查后排序
    }

    getContainerWidth = () => {
        const observer = new ResizeObserver(e => {
            e.forEach(entry => {
                this.setState({
                    containerWidth: entry.contentRect.width
                })
            });
        });
        const target = document.querySelector('.btnListClass');
        target && observer.observe(target);
    }

    getPositionMaintenanceData(callback) {
        getAllPositionTypeData({}, (data) => {
            let typeData = [];
            if (data && data.length) {
                typeData = data.map(item => {
                    return {
                        ...item,
                        key: item.id
                    }
                })
            }
            this.setState({
                typeData
            }, () => {
                callback && callback()
            })
        })
    }

    getMainUnitData() {
        this.request({
            url: "/cm-sites-sys/dept/getDeptAndSon",
            body: ["0"],
            method: "post",
            contentType: "json",
            callBack: (data) => {
                let mainUnitData = [];
                if (data && data.length) {
                    mainUnitData = data.map(item => {
                        return {
                            ...item,
                            key: item.id
                        }
                    })
                }
                this.setState({
                    mainUnitData
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    getActivityType() {
        let params = {
            pageNum: 1,
            pageSize: 10
        };
        getActivityTypeData(params, (res) => {
            let activityTypeData = [];
            if (res && res.data && res.data.length) {
                activityTypeData = res.data;
            }
            this.setState({
                activityTypeData
            })
        })
    }

    getListData() {
        let sortObj = this.sortWay.getData();
        this.request({
            url: "/cm-sites-media-consumer/position/management/list",
            body: {
                ...this.state.params,
                grade: this.state.grade,
                follow: this.state.follow,
                ...sortObj
            },
            callBack: (data) => {
                let cardData = [];
                let listData = [];
                if (data && data.length) {
                    cardData = this.getCardData(data);
                    listData = data;
                }
                this.setState({
                    cardData,
                    listData,
                    isZombieCardData: false
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    dataIndex = {
        positionTypeName: "positionTypeName",
        logo: "logo",
    }

    getCardData(data) {
        return data.reduce((arr, item) => {
            const existingItem = arr.find(arrItem => (arrItem.positionTypeName === item.positionTypeName) && (arrItem.positionTypeId === item.positionTypeId));

            if (existingItem) {
                existingItem.child.push({...item});
            } else {
                arr.push({
                    type: item.type,
                    positionTypeId: item['positionTypeId'],
                    positionTypeName: item['positionTypeName'],
                    logo: this.getIcon(item),
                    child: [{...item}],
                });
            }
            return arr;
        }, []);
    }

    getIcon(item) {
        let {typeData} = this.state;
        // 根据阵地类型ID获取对应类型
        let typeItem = typeData.length && typeData.find(typeItem => typeItem.id === item.positionTypeId);
        return typeItem && typeItem[this.dataIndex["logo"]];
    }

    refreshList() {
        this.getListData();
    }

    // 状态卡片筛选点击方法
    onClickScreenCard = (item, clickType) => {
        let screenKey = clickType === "first" ? "statusType" : "activity";
        this.onChange(screenKey, item.statusType, clickType);
    }

    // 等级筛选点击方法
    gradeTabChange = (val) => {
        this.state.grade = val;
        setTimeout(() => {
            this.refreshList();
        }, 100)
    }

    onChange = (key, val, clickType) => {
        if (val || val === 0) {
            this.state.params[key] = val;
        } else {
            delete this.state.params[key];
        }
        if (clickType) this.handleCardClickParams(clickType); //处理卡片点击传参
        this.handleBatchAuditBtnShow(val, clickType); //处理批量审核按钮是否显示
        this.refreshList()
    };

    handleCardClickParams(clickType) {
        if (clickType === "first") {
            delete this.state.params["activity"];
        } else {
            delete this.state.params["statusType"];
        }
    }

    handleBatchAuditBtnShow(val, clickType) {
        let meHandleData = this.screenCardRef.current.state.meHandleData;
        this.state.showBatchAuditBtn = !!(meHandleData.activityList && meHandleData.activityList.length && meHandleData.activityList.find(item => item.type === val) && val !== 5 && clickType === "second");
        this.state.showBatchLingQuBtn = !!(val === 5 && clickType === "second");
        this.setState({})
    }


    /**
     * 获取左侧筛选区
     * */
    selectList() {
        const annualReviewData = this.state.activityTypeData.find(item => item.type === 4);
        
        return [
            [
                {
                    type: 2,
                    component: 'select',
                    placeholder: '媒体平台',
                    labelCode: 'positionTypeId',
                    value: this.state.params.positionTypeId || undefined,
                    selectValues: this.state.typeData,
                    onChange: (val) => {
                        this.onChange('positionTypeId', val)
                    },
                    styleOut: {padding: "0 24px 12px 0"},
                },
                // {
                //     type: 2,
                //     component: 'select',
                //     placeholder: '活跃度',
                //     labelCode: 'activeType',
                //     value: (this.state.params.activeType || this.state.params.activeType === 0) ? this.state.params.activeType : undefined,
                //     selectValues: [
                //         {key: 0, name: "最近一天"},
                //         {key: 1, name: "最近一周"},
                //         {key: 2, name: "最近一月"},
                //         {key: 3, name: "最近一年"},
                //     ],
                //     onChange: (val) => {
                //         this.onChange('activeType', val)
                //     },
                //     styleOut: {padding: "0 24px 12px 0"},
                // },
                {
                    type: 2,
                    component: 'select',
                    placeholder: '主责单位',
                    labelCode: 'mainDeptId',
                    value: this.state.params.mainDeptId || undefined,
                    selectValues: this.state.mainUnitData,
                    onChange: (val) => {
                        this.onChange('mainDeptId', val)
                    },
                    styleOut: {
                        padding: "0 24px 12px 0",
                        width: 220,
                        display: typeof CUSTOM_CONFIG?.NEW_MEDIA_MANAGE?.SHOW_MAIN_DEPT === "function" ?
                            (CUSTOM_CONFIG.NEW_MEDIA_MANAGE.SHOW_MAIN_DEPT(this) ? "inline-block" : "none")
                            : this.permissionCheck("pms:positionManage:all") ? "inline-block" : "none"
                    },
                    style: {width: "100%"}
                },
                {
                    type: 2,
                    component: 'select',
                    placeholder: '所属部门',
                    labelCode: 'belongDeptId',
                    value: this.state.params.belongDeptId || undefined,
                    selectValues: this.state.mainUnitData,
                    onChange: (val) => {
                        this.onChange('belongDeptId', val)
                    },
                    styleOut: {
                        padding: "0 24px 12px 0",
                        width: 220,
                        display: this.permissionCheck("pms:positionManage:all") ? "inline-block" : "none"
                    },
                    style: {width: "100%"}
                },
                {
                    type: 2,
                    component: 'select',
                    placeholder: '平台划分',
                    labelCode: 'divisionName',
                    value: this.state.params.divisionName || undefined,
                    selectValues: this.state.divisionNameData,
                    onChange: (val) => {
                        this.onChange('divisionName', val)
                    },
                    styleOut: {
                        padding: "0 24px 12px 0",
                        display: this.sysConfigGetValueByKey("position.platform.divide.screen", "no") === "no" ? "none" : "inline-block",
                    },
                },
                {
                    type: 2,
                    component: 'select',
                    placeholder: '年审状态',
                    labelCode: 'annualAuditType',
                    value: this.state.params.annualAuditType || undefined,
                    selectValues: [
                        {key: 3, name: "本年度未年审"},
                        {key: 2, name: "本年度已年审"},
                    ],
                    onChange: (val) => {
                        this.onChange('annualAuditType', val)
                    },
                    styleOut: {
                        padding: "0 24px 12px 0", 
                        width: 160,
                         display: CUSTOM_CONFIG?.NEW_MEDIA?.ANNUAL_TYPE_SELECT_DISPLAY||(annualReviewData&&annualReviewData.status!==0 ? "inline-block" : "none")
                    },
                    style: {width: "100%"}
                },
                ...(typeof CUSTOM_CONFIG?.NEW_MEDIA_MANAGE?.SELECT_LIST_FUN === "function" ? CUSTOM_CONFIG.NEW_MEDIA_MANAGE.SELECT_LIST_FUN(this) : []),
                {
                    type: 1,
                    component: <Button onClick={() => {
                        this.state.params = {};
                        this.state.showBatchAuditBtn = false;
                        this.state.showBatchLingQuBtn = false;
                        this.screenCardRef.current.clearDivClick();
                        this.refreshList();
                    }}>重置</Button>,
                    styleOut: {padding: "0 24px 12px 0"},
                }
            ]
        ]
    };

    // 点击展开收起按钮
    expandable(val) {
        this.state.isOpen = val;
        this.setState({})
    }

    exportPosition() {
        let codes = this.state.listData.map(item => item.code);
        if(!codes || !codes.length) {
            message.info("当前列表为空，无法导出");
            return;
        }
        this.request({
            url: "/cm-sites-media-consumer/position/handler/output",
            body: {
                codes
            },
            method: "downloadPost",
            callBack: (res) => {
                if (res) {
                    message.success("导出成功");
                }
            },
        })
    }

    openEntry = (item) => {
        this.entryList.open(item)
    }

    /**
     * 获取右侧筛选区
     * */
    btnList() {
        let {activityTypeData} = this.state;
        // 定义一个映射，根据type生成配置项
        const buttonFactories = {
            0: (item, index) => ({
                type: 1,
                component: <BtnGroup btnName={"我要" + item.name} onClick={() => {
                    this.positionAdd.showAddModal(item);
                }} menuData={[
                    {
                        name: "我要" + item.name, onClick: () => {
                            this.positionAdd.showAddModal(item);
                        }
                    },
                    {
                        name: "批量备案", onClick: () => {
                            this.batchAdd();
                        }
                    }
                ]}/>,
                styleOut: {
                    padding: "0 0 12px 0",
                    display: item.status && this.permissionCheck("pms:positionManage:addBtn") ? "inline-block" : "none"
                },
                key: `dynamic-btn-${index}`
            }),
            5: (item, index) => ({
                type: 1,
                component: <BtnGroup type={"default"} btnName={"我要" + item.name} onClick={() => {
                    this.positionAdd.showAddModal(item);
                }} menuData={[
                    {
                        name: "我要" + item.name, onClick: () => {
                            this.positionAdd.showAddModal(item);
                        }
                    },
                    {
                        name: "批量分派",
                        onClick: () => {
                            this.batchAssignment();
                        }
                    }
                ]}/>,
                styleOut: {
                    padding: "0 0 12px 24px",
                    display: item.status && this.permissionCheck("pms:positionManage:assignment") ? "inline-block" : "none"
                },
                key: `dynamic-btn-${index}`
            })
        };

        const dynamicButtons = activityTypeData
            .filter(item => item.status)
            .map((item, index) => {
                return buttonFactories[item.type] ? buttonFactories[item.type](item, index) :
                    {
                        type: 1,
                        component: <Button onClick={() => this.openEntry(item)}>{"我要" + item.name}</Button>,
                        styleOut: {
                            padding: "0 0 12px 24px",
                            display: item.status ? "inline-block" : "none"
                        },
                        key: `dynamic-btn-${index}`
                    }
            })
            .filter(Boolean);

        const baseButtons = [
            ...dynamicButtons,
            {
                type: 1,
                component: <Button onClick={() => {
                    this.batchAudit({name: "批量审核", key: "batchAudit"})
                }}>批量审核</Button>,
                styleOut: {
                    padding: "0 0 12px 24px",
                    display: this.state.showBatchAuditBtn && this.permissionCheck("pms:positionManage:batchAudit") ? "inline-block" : "none"
                },
                key: "batchAudit"
            },
            {
                type: 1,
                component: <Button onClick={() => {
                    this.batchTransfer()
                }}>批量转交</Button>,
                styleOut: {
                    padding: "0 0 12px 24px",
                    display: this.permissionCheck("pms:positionManage:batchTransfer") ? "inline-block" : "none",
                },
                key: "batchTransfer"
            },
            {
                type: 1,
                component: <Button onClick={() => {
                    this.batchAudit({name: "批量领取", key: "batchLinQu"})
                }}>批量领取</Button>,
                styleOut: {
                    padding: "0 0 12px 24px",
                    display: this.state.showBatchLingQuBtn && this.permissionCheck("pms:positionManage:batchLingQu") ? "inline-block" : "none"
                },
            },
            {
                type: 1,
                component: <Button onClick={() => {
                    this.clickSignOutNotRecord({name: "添加已注销账号", type: 2})
                }}>添加已注销账号</Button>,
                styleOut: {
                    padding: "0 0 12px 24px",
                    display: this.permissionCheck("pms:positionManage:signOutNotRecord") ? "inline-block" : "none",
                },
                key: "addSignOut"
            }
        ];
        let newBaseButtons = this.getNewButtons(baseButtons);
        return [newBaseButtons];
    }

    getNewButtons = (baseButtons) => {
        const containerWidth = this.state.containerWidth; // 容器实际宽度
        const btnWidthList = this.state.btnWidthList; // 每个按钮的实际宽度数组

        // 计算可以显示的按钮数量
        let currentWidth = 0;
        let buttonsToShowCount = 0;
        let visibleButtons = baseButtons.filter(item => item?.styleOut?.display !== "none");
        for (let i = 0; i < visibleButtons.length; i++) {
            const buttonWidth = btnWidthList[i]; // 获取当前按钮的宽度
            const newWidth = currentWidth + buttonWidth;
            // 如果加入当前按钮会导致总宽度超过容器宽度，则停止循环
            if (newWidth + 106 > containerWidth) { // 106 是“更多”按钮的宽度
                break;
            }
            currentWidth = newWidth;
            buttonsToShowCount++;
        }

        let showButtons = visibleButtons.slice(0, buttonsToShowCount);
        let overflowButtons = visibleButtons.slice(buttonsToShowCount); // 剩余的按钮放入 Dropdown
        // 如果有需要放入 Dropdown 的按钮
        if (overflowButtons.length > 0) {
            showButtons.push({
                type: 1,
                component: (
                    <Dropdown overlay={<div style={{
                        display: "flex",
                        flexDirection: "column"
                    }}>{overflowButtons.map((button, index) => {
                        return (
                            <div style={{paddingBottom: 3}} key={index}>{button.component}</div>
                        )
                    })}</div>}>
                        <Button icon={"ellipsis"}>
                            更多
                        </Button>
                    </Dropdown>
                ),
                styleOut: {
                    padding: "0 0 12px 24px",
                    display: "inline-block",
                },
                key: "more"
            });
        }
        return showButtons;
    }

    openOperate() {
        return [
            [
                {
                    type: 2,
                    component: "unfold",
                    onChange: (val) => {
                        this.expandable(val)
                    },
                    styleOut: {
                        padding: "0 0 12px 24px",
                    },
                },
                {
                    type: 1,
                    component: <Button onClick={() => {
                        this.exportPosition()
                    }}>导出账号</Button>,
                    styleOut: {
                        padding: "0 0 12px 24px",
                        display: this.permissionCheck("pms:positionManage:export") ? "inline-block" : "none",
                    },
                },
                {
                    type: 2,
                    component: 'search',
                    placeholder: '请输入账号名称关键词',
                    labelCode: 'query',
                    value: this.state.params.query,
                    styleOut: {padding: "0 0 12px 0"},
                    style: {width: "100%"},
                    onSearch: (val) => {
                        this.state.params.query = val;
                        this.refreshList();
                    },
                    onChange: (val) => {
                        this.state.params.query = val;
                        this.setState({})
                    },
                }
            ]
        ]
    }

    clickSignOutNotRecord(item) {
        this.positionAdd.signOutNotRecord(item);
    }

    batchTransfer() {
        window.location.hash = "/newMedia/positionManage/batchTransfer";
    }

    batchAudit(btnItem) {
        let {activity} = this.state.params;
        let params = {
            activity,
            btnItem
        };
        setInfoToLocalStorage("batchAudit", params);
        window.location.hash = "/newMedia/positionManage/batchAudit";
    }

    batchAdd() {
        window.location.hash = "/newMedia/positionManage/batchAdd";
    }

    batchAssignment() {
        window.location.hash = "/newMedia/positionManage/batchAssignment";
    }

    buttonContainerWidth = 65;

    renderScreenList() {
        return (
            <div style={{
                padding: "0 32px",
                height: this.state.isOpen ? "auto" : 44,
                overflow: this.state.isOpen ? "" : "hidden"
            }}>
                <div style={{display: "flex", width: "100%", justifyContent: "space-between"}}>
                    <div className={"btnListClass"} style={{width: this.buttonContainerWidth + "%"}}>
                        <SearchTemplate
                            rowStyle={{flexWrap: "nowrap"}}
                            btnList={this.btnList()}
                            onResize={(offsetHeight) => {
                                if (this.searchHeight != offsetHeight) {
                                    this.searchHeight = offsetHeight;
                                    this.setState({});
                                }
                            }}
                            onColWidthsChange={(btnWidthList) => {
                                this.setState({btnWidthList})
                            }}
                            ref={(ref) => {
                                this.search = ref;
                            }}
                        />
                    </div>
                    <div style={{width: (100 - this.buttonContainerWidth) + "%"}}>
                        <SearchTemplate
                            rowStyle={{flexDirection: "row-reverse", flexWrap: "nowrap"}}
                            btnList={this.openOperate()}
                            onResize={(offsetHeight) => {
                                if (this.searchHeight != offsetHeight) {
                                    this.searchHeight = offsetHeight;
                                    this.setState({});
                                }
                            }}
                            ref={(ref) => {
                                this.search = ref;
                            }}
                        />
                    </div>
                </div>
                <div style={{width: "100%"}}>
                    <SearchTemplate
                        btnList={this.selectList()}
                        onResize={(offsetHeight) => {
                            if (this.searchHeight != offsetHeight) {
                                this.searchHeight = offsetHeight;
                                this.setState({});
                            }
                        }}
                        ref={(ref) => {
                            this.search = ref;
                        }}
                    />
                </div>
            </div>
        )
    }

    toggleClick = (item) => {
        this.setState({
            modeKey: item.key
        })
    }

    clickItem = (item) => {
        if (!item.id) {
            message.info("账号异常");
            return;
        }
        this.positionAdd.showEditModal(item.id);
    }

    goToItem = (item, activityTypeItem) => {
        if (!item.id) {
            message.info("账号异常");
            return;
        }
        this.positionAdd.entryOpenModal(item.id, activityTypeItem);
    }

    refreshToDoGet = () => {
        this.screenCardRef.current.state.selectKey = "pendingCount";
        this.onChange("activity", 5, "second");
    }

    getMediaSort = () => {
        this.request({
            url: '/cm-sites-media-consumer/system/positionType/list',
            method: 'get',
            body: {
                pageNum: 1,
                pageSize: 100
            },
            callBack: (res) => {
                if(res) {
                    const sortMediaData = res.data.map(item => {
                        return { positionTypeId: item.id, positionTypeName: item.name}
                    })
                    this.setState({
                        mediaSort: sortMediaData
                    })
                }
            }
        })
    }

    sortZombieData = (zombieCardData, mediaSort) => {
        const sortIndexMap = new Map();
        mediaSort.forEach((item, index) => {
            sortIndexMap.set(item.positionTypeId, index);
        });
        return zombieCardData.sort((a, b) => {
            const indexA = sortIndexMap.get(a.positionTypeId);
            const indexB = sortIndexMap.get(b.positionTypeId);

            if (indexA === undefined) return 1;
            if (indexB === undefined) return -1;
    
            return indexA - indexB;
        });
    }
    getZombieData = () => {
        let sortObj = this.sortWay.getData();
        this.request({
            url: '/cm-sites-media-consumer/zombie/listZombiePosition',
            method: 'get',
            body: {
                ...this.state.params,
                grade: this.state.grade,
                ...sortObj
            },
            callBack: (res) => {
                let zombieCardData = [];
                if (res && res.length) {
                    // 将僵尸号数据根据媒体排序进行排序
                    zombieCardData = this.sortZombieData(this.getZombieCardData(res), this.state.mediaSort)
                    this.setState({
                        cardData: zombieCardData,
                        isZombieCardData: true
                    })
                }
            }
        })
    }

    getZombieCardData = (data) => {
        const filterData = data.reduce((pre, cur) => {
            cur.positionList.reduce((arr, item) => {
                const parentElement = pre.find(target => target.positionTypeId === item.positionTypeId && target.positionTypeName === item.positionTypeName);
                if (parentElement) {
                    const sameTimeAndColor = parentElement.child.find(target => target.overTime === cur.overTime && target.overColor === cur.overColor);
                    if (sameTimeAndColor) {
                        sameTimeAndColor.child.push(item);
                    } else {
                        parentElement.child.push({
                            overTime: cur.overTime,
                            overColor: cur.overColor,
                            child: [item]
                        })
                    }
                } else {
                    pre.push({
                        positionTypeName: item.positionTypeName,
                        positionTypeId: item.positionTypeId,
                        logo: this.getIcon(item),
                        child: [{
                            overTime: cur.overTime,
                            overColor: cur.overColor,
                            child: [item]
                        }]
                    })
                }
                return arr;
            }, []);
            return pre;
        }, []);
        return filterData;
    }

    tabsTopPadding = 11;
    tabsHeight = 60;
    pageMargin = 15;
    screenCardHeight = 168;
    searchHeight = 44;
    topMenuHeight = 70; //顶部菜单高度
    otherHeight = this.tabsTopPadding + this.searchHeight + this.pageMargin * 3 + this.tabsHeight + this.screenCardHeight + this.topMenuHeight; // 除表格外的其他所有高度集合
    tableHeight = `calc(100vh - ${this.otherHeight + "px"})`;

    loadKey = uuid();
    screenCardKey = uuid();

    render() {
        let {modeKey, listData, cardData, isZombieCardData, activityTypeData, typeData} = this.state;
        const annualReviewData = activityTypeData.find(item => item.type === 4);
        return (
            <>
                <div style={{height: 'calc(100vh - 100px)', marginTop: 15}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={'calc(100vh - 100px)'} style={{borderRadius: "5px"}}>
                        <div style={{padding: "0px 15px", borderRadius: "5px"}}>
                            <GradeTabs ref={(gradeTabs) => this.gradeTabs = gradeTabs} onChange={this.gradeTabChange}
                                       style={{padding: `${this.tabsTopPadding + "px"} 0 0 0`}}
                                       onResize={(offsetHeight) => {
                                           if (this.tabsHeight != offsetHeight) {
                                               this.tabsHeight = offsetHeight;
                                               this.setState({});
                                           }
                                       }}>
                                <ScreenCard onClickScreenCard={this.onClickScreenCard}
                                            activityTypeData={activityTypeData}
                                            key={this.screenCardKey}
                                            ref={this.screenCardRef}
                                            onResize={(offsetHeight) => {
                                                if (this.screenCardHeight != offsetHeight) {
                                                    this.screenCardHeight = offsetHeight;
                                                    this.setState({});
                                                }
                                            }}
                                            style={{padding: "8px 32px 12px 32px"}}/>
                                {this.renderScreenList()}
                            </GradeTabs>
                            <PageTemplate styleOut={{margin: 0}}>
                                <div style={{padding: "32px 0"}}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: !isZombieCardData ? 'space-between' : "flex-end",
                                        alignItems: "center",
                                        marginBottom: 24
                                    }}>
                                        <SortWay listData={listData} ref={ref => this.sortWay = ref}
                                                 isShow={!isZombieCardData}
                                                 options={[
                                                     {
                                                         key: "createTime",
                                                         value: "createTime",
                                                         label: "创建时间"
                                                     },
                                                     {
                                                         key: "updateTime",
                                                         value: "updateTime",
                                                         label: "更新时间"
                                                     }
                                                 ]}
                                                 defaultValue="createTime"
                                                 refreshList={() => this.refreshList()}/>
                                        {this.state.modeKey === "card" && this.sysConfigGetValueByKey("newMedia.zombieBtn.show", "true") === "true" ?
                                            <div style={{display: "flex", flex: 1, justifyContent: "flex-end", marginRight: 16}}>
                                                {!isZombieCardData ? <Button type="default" onClick={() => {
                                                        this.getZombieData()
                                                    }}>僵尸号排查</Button> :
                                                    <Button type="default" onClick={() => {
                                                        this.setState({isZombieCardData: false}, () => {
                                                            this.getListData();
                                                        });
                                                    }}>取消排查</Button>}
                                            </div> : <div style={{display: "flex", flex: 1, justifyContent: "flex-end", marginRight: 16}}></div>}
                                        {(this.state.modeKey === "card" && !isZombieCardData) &&
                                            <Radio.Group style={{marginRight: 16}} value={this.state.follow} onChange={(e) => {
                                                this.state.follow = e.target.value;
                                                this.getListData();
                                            }}>
                                                <Radio.Button value={false}>所有</Radio.Button>
                                                <Radio.Button value={true}>重点关注</Radio.Button>
                                            </Radio.Group>}
                                        <ModeSelect onClick={(item) => this.toggleClick(item)}/>
                                    </div>
                                    {(listData && listData.length > 0) ?
                                        (() => {
                                            switch (this.state.modeKey) {
                                                case "card":
                                                    return <PositionCard refreshList={() => this.refreshList()}
                                                                         actions={this} cardData={cardData}
                                                                         isZombieCardData={isZombieCardData}
                                                                         activityTypeData={activityTypeData}
                                                                         typeData={typeData}
                                                                         clickItem={this.clickItem}/>;
                                                case "list":
                                                    return <PositionList refreshList={() => this.refreshList()}
                                                                         listData={listData}
                                                                         typeData={typeData}
                                                                         activityTypeData={activityTypeData}
                                                                         clickItem={this.clickItem}/>;
                                                default:
                                                    return null
                                            }
                                        })() : <NoData/>}
                                </div>
                            </PageTemplate>
                        </div>
                    </Scrollbars>
                </div>
                <PositionAdd
                    key={this.loadKey}
                    ref={ref => this.positionAdd = ref}
                    onCancel={() => {
                        // 重新加载新增流程
                        this.loadKey = uuid();
                        this.setState({})
                    }}
                    onOkCall={() => {
                        // 重新加载新增流程
                        this.loadKey = uuid();
                        this.screenCardKey = uuid();
                        this.refreshList();
                        this.entryList.refreshList(); //刷新快速入口列表
                    }}
                />
                <ToDoGet refreshList={() => this.refreshToDoGet()}/>
                <EntryList ref={ref => this.entryList = ref} goToItem={this.goToItem} annualReviewData={annualReviewData}/>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(PositionManage);